export const startWebRecording = async (chunksRef, streamRef) => {
    const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
    streamRef.current = stream;

    const recorder = new MediaRecorder(stream);
    chunksRef.current = [];

    recorder.ondataavailable = (event) => {
        if (event.data.size > 0) {
            chunksRef.current.push(event.data);
        }
    };

    recorder.start();
    return recorder;
};

export const stopWebRecording = (recorder, chunksRef, streamRef) => {
    return new Promise((resolve) => {
        recorder.onstop = () => {
            const blob = new Blob(chunksRef.current, { type: "audio/webm" });

            // stop microphone
            if (streamRef.current) {
                streamRef.current.getTracks().forEach((t) => t.stop());
                streamRef.current = null;
            }

            resolve(blob);
        };

        recorder.stop();
    });
};